<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="$permission.canEdit()"
      unit="不支持配送区域"
      edit-title
      id-key="RecordId"
      form-label-width="85px"
      :data="data"
      :form-rules="rules"
      :save-func="() => {}"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <!-- <el-row>
          <el-col
            :span="$store.state.isMB ? 24 : 12"
            v-if="loginInfo.UserType == 0"
          >
            <el-form-item
              label="所属商家"
              prop="StoreId"
              :rules="loginInfo.UserType == 0 ? typeRules.StoreId : null"
            >
              <busi-select
                v-model="data.StoreId"
                ref="busiSelect"
                :checkState="CheckState"
              ></busi-select>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="24">
            <el-row :gutter="10">
              <el-col :span="12">
                <districts
                  ref="districts"
                  :Lvs="[1, 2]"
                  height="400px"
                  @select="onSelect"
                />
              </el-col>
              <el-col :span="12">
                <div class="citys-head">选中的城市</div>
                <div class="citys-box m-scroll" style="height: 400px">
                  <div class="item" v-for="(i, key) in Districts" :key="key">
                    <span>{{ i.Name }}</span>
                    <span
                      @click="remove(i.DistrictId, key)"
                      class="el-icon-error close-btn"
                    ></span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24"> </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import busiSelect from "@/components/shop/business/select";
import districts from "@/components/sale/freight/cityTree";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    busiSelect,
    districts,
  },
  data() {
    return {
      data: {
        StoreId: 0,
      },
      tableDel: [],
      select: [],
      Districts: [],
      api: require("@/api/sale/freightUnsupport").default,
      rules: {
        TemplateName: [{ required: true, message: "模板名称不能为空" }],
        DeliveryRange: [{ required: true, message: "配送范围不能为空" }],
        DeliveryWay: [{ required: true, message: "配送方式不能为空" }],
        // OrderId: [{ required: true, message: "序号不能为空" }],
      },
      typeRules: {
        StoreId: [{ required: true, message: "请选择所属商家" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      CheckState: 2,
    };
  },

  computed: {},
  methods: {
    onCreateOpened() {
      this.tableDel = [];
      this.Districts = [];
      var data = {};
      this.api.list({}).then((res) => {
        if (res.Code == 0) {
          if (res.Data) {
            var filterIds = res.Data.map((x) => x.DistrictId);
            data.filterIds = filterIds;
            this.$refs.districts.init(data);
          } else {
            this.$refs.districts.init(data);
          }
        }
      });
    },
    onSelect(data) {
      var ids = data.IdChain.split(".");
      console.log(ids, "onselect");
      var item = {
        RecordId: 0,
        StoreId: 0,
        TemplateId: 0,
        OrderId: 0,
        ProvinceId: ids[0],
        CityId: ids.length > 1 ? ids[1] : ids[0],
        DistrictId: ids.length > 2 ? ids[2] : ids.length > 1 ? ids[1] : ids[0],
        Name: data.NameChain,
      };
      if (item) this.Districts.push(item);
    },
    onEditOpened() {},
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
      if(this.Districts.length==0){
        this.$message.warning("不支持配送区域不能为空");
        return false;
      }
    data.UnSupports=this.Districts;
      console.log(data, "bbb");
      this.loading();
      this.api.saveAll(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.onClosed();
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
     this.Districts=[];
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  line-height: 40px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
</style>
<style lang="scss">
.tabs_box {
  margin: 0;
  .el-tabs__header {
    margin: 0;
  }
}
</style>

<style lang="scss" scoped>
.citys-head {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
.citys-box {
  overflow-y: auto;
  border: 1px solid #ebeef5;
  .item {
    line-height: 40px;
    font-size: 16px;
    width: 100%;
    display: inline-block;
    padding-left: 10px;
    cursor: default;
    .close-btn {
      float: right;
      line-height: 40px;
      margin-right: 13px;
      color: #7b7b7b;
    }
  }
  .item:hover {
    background-color: #eefff9;
  }
}
</style>